// extracted by mini-css-extract-plugin
export var section = "faq-discord-module--section--fa2d2";
export var title = "faq-discord-module--title--2bd23";